import { Component } from "react";
import Indent from '../../../../../assets/images/module/general/Indent.svg'

export class CustomIndentBtn extends Component {
  render() {
    return (
      <div 
        className="rdw-option-wrapper indent-custom-class" 
        onClick={this.props.onCustomIndent}
        title="Einrücken"
      >
        {/* <span style={{fontWeight: 'bold', fontSize: '18px'}}>⇥</span>  */}
        <img src={Indent} alt="Indent" style={{width: '16px', height: '14px'}} />
        {/* Replace the span with an icon like <FormatIndentIncreaseIcon /> if preferred */}
      </div>
    );
  }
}